// 🔗 B292 Fase 1 (AI_132) — envio do documento ao paciente por SMS.
// Chama o endpoint médico-only /api/enviar-documento, que monta a URL de
// validação (B290) e dispara o SMS pelo provedor (chave só no servidor). Aqui
// trafega só o CÓDIGO do documento — nunca o telefone nem o conteúdo.
//
// Retorna { ok, erro?, jaEnviado? } — devolve a mensagem específica do servidor
// (ex.: "Paciente sem celular válido cadastrado") em vez de um genérico, para o
// médico saber se é p/ corrigir o cadastro ou só tentar de novo. Trata sessão
// perdida (token nulo) distinta de falha de envio.
import { getIdTokenSafe } from "../../../lib/authFetch";

export interface ResultadoEnvio {
  ok: boolean;
  erro?: string;
  jaEnviado?: boolean;
  /** Canal que efetivamente enviou: "whatsapp" | "sms". */
  canal?: string;
}

const ROTULO = "enviar-documento";

export async function enviarDocumentoPaciente(codigo: string): Promise<ResultadoEnvio> {
  let token = await getIdTokenSafe(ROTULO);
  if (!token) return { ok: false, erro: "Sessão expirada. Entre novamente." };

  const chamar = (tk: string) =>
    fetch("/api/enviar-documento", {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${tk}` },
      body: JSON.stringify({ codigo }),
    });

  try {
    let r = await chamar(token);
    if (r.status === 401) {
      // Janela rara: token vivo no SDK do client, morto no server → força refresh.
      token = await getIdTokenSafe(ROTULO, true);
      if (!token) return { ok: false, erro: "Sessão expirada. Entre novamente." };
      r = await chamar(token);
    }
    const data = (await r.json().catch(() => ({}))) as {
      error?: string;
      jaEnviado?: boolean;
      canal?: string;
    };
    if (r.ok) return { ok: true, jaEnviado: !!data.jaEnviado, canal: data.canal };
    return { ok: false, erro: data.error || "Não foi possível enviar agora." };
  } catch {
    return { ok: false, erro: "Falha de conexão ao enviar." };
  }
}
